/**
 * Layout Component
 *
 * Simple layout wrapper for non-map routes.
 * Provides Sidebar and content area.
 */

import { ReactNode } from 'react'
import Sidebar from './Sidebar'

interface LayoutProps {
  readonly children: ReactNode
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className='h-screen w-screen bg-gray-50'>
      <div className='h-full w-full grid grid-cols-1 lg:grid-cols-[280px_1fr]'>
        <Sidebar
          onCreate={() => {
            // No-op for non-map routes
          }}
          isMapView={false}
        />
        <div className='relative bg-white overflow-y-auto'>{children}</div>
      </div>
    </div>
  )
}
